import config from '@/config'
import Conversations, { ConversationType } from '@/models/Conversation'
import { PaginationParams } from '@/types/PaginationParams'
import BaseService from './BaseService'
import { requests } from './HTTPService'

const http = requests(config?.COMMUNITIES_SERVER_URL)
export default class ConversationsService extends BaseService<Conversations> {
  model(): typeof Conversations {
    return Conversations
  }

  constructor(locationId: string) {
    super(locationId)
    this.basePath = `/${locationId}/conversations`
  }

  createConversation(
    members: Array<string>,
    type: ConversationType
  ): Promise<any> {
    return http.post(`${this.endpoint}`, { members, type }).then((res: any) => {
      return res.data
    })
  }

  async getConversations(query?: any): Promise<any> {
    const response = await http.get(`${this.endpoint}`, {
      params: query,
    })
    return response.data
  }

  async getConversationById(conversationId: string): Promise<any> {
    const response = await http.get(`${this.endpoint}/${conversationId}`)
    return response.data
  }

  async clearConversation(conversationId: string): Promise<any> {
    const response = await http.delete(`${this.endpoint}/${conversationId}`)
    return response.data
  }

  async blockConversation(conversationId: string): Promise<any> {
    const response = await http.post(`${this.endpoint}/${conversationId}/block`)
    return response.data
  }

  async unblockConversation(conversationId: string): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/${conversationId}/unblock`
    )
    return response.data
  }

  async markConversationAsRead(conversationId: string): Promise<any> {
    const response = await http.post(`${this.endpoint}/${conversationId}/read`)
    return response.data
  }

  async getConversationSuggestions(query?: any): Promise<any> {
    const response = await http.get(`${this.endpoint}/suggestions`, {
      params: query,
    })
    return response.data
  }

  async getConversationHistory(
    conversationId: string,
    paginationParams: PaginationParams
  ): Promise<any> {
    const response = await http.get(
      `${this.endpoint}/${conversationId}/messages`,
      {
        params: { ...paginationParams, sort: paginationParams.pageSort },
      }
    )
    return response.data
  }
}
